<template class="pendencyBody">
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-row>
        <b-navbar-nav>
          <b-button @click="goBack" size="xxl" variant="light">
            <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
          </b-button>
        </b-navbar-nav>

        <b-col md="8">
          <h5 class="page-title mb-2">
            <b> {{ $route.name }} </b>
          </h5>
        </b-col>
      </b-row>

      <div class="mt-3">
        <!-- Search Form Input Start-->
        <b-row>
          <b-col md="8" class="my-1">
            <b-form-group>
              <b-input-group>
                <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                  placeholder="Type to Search Assignment" ref="search" />

                <b-input-group-append class="mr-1">
                  <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>

              <b-col md="3">
                <label v-if="activeUserPreference">
                  <b> Created User Filter</b>
                </label>
                <model-list-select v-if="activeUserPreference" :list="$store.getters['common/getAllUserList']"
                  id="addedUserFilter" @input="debounceSearch" v-model="Filter.userFilter" option-value="userId"
                  option-text="employeeName" placeholder="Select Created User"></model-list-select>
              </b-col>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-button :pressed="activeButtonBranch" v-model="activeButtonBranch"
              :variant="activeButtonBranch ? 'success' : 'danger'" @click="BranchBtnFilter(activeButtonBranch)">Branch
              {{ activeButtonBranch ? " Filter On" : " Filter Off" }}</b-button>
            <!-- :PMC_USERID="$sessionsStorage.get('userId')" -->
            <userBasedClient v-if="$sessionsStorage.get('userId')"
              :PMC_title="'User Summary - ' + $sessionsStorage.get('employeeName')" :PMC_USERID="Filter.userFilter"
              :PMC_USERNAME="$sessionsStorage.get('nameUser')" :PMC_USERDESIG="$sessionsStorage.get('designation')"
              :PMC_BranchClientPre="$sessionsStorage.get('branchclientPre')"
              :PMC_TransportTypePre="$sessionsStorage.get('transportTypePre')"
              :PMC_UserEmpName="$sessionsStorage.get('employeeName')"
              :PMC_UserEmpCode="$sessionsStorage.get('employeeCode')" />
          </b-col>

          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ JOBList.length }} Entries</small>
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" class="my-1">
            <b-button class="pull-right mb-1" v-if="JOBList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('checkCCExpJobPendency', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
            <b-button class="pull-right mb-1" @click="closeAssignmentPendencyList" size="sm" variant="outline-info"
              style="font-size: 0.675rem">Close Assignment Pendency</b-button>
            <b-pagination limit="5" :total-rows="JOBList.length" :per-page="perPage" v-model="currentPage"
              class="my-0 pull-right" />
          </b-col>
        </b-row>

        <div class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar">
          <b-table show-empty stacked="md" responsive :fields="columnMain" :items="JOBList"
            class="table-background position-relative" :per-page="perPage" :current-page="currentPage" :filter="filter"
            @filtered="onFiltered">
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="Branch" slot-scope="row1">
              <tr :class="{ blink: isBlinking(row1.item) }">
                <td>
                  <div :class="{ 'blink-circle': shouldBlink(row1.item) }"></div>
                </td>
              </tr>
              <span>{{ row1.item.Branch }}</span><br />
              <span>{{ "Manifest : " + row1.item.is_manifestation_status }}</span><br />
              <span>Billing : </span>
              <div class="text-left" v-if="row1.item.TallyBillingSeries">
                <div v-if="row1.item.TallyBillingSeries">
                  <span v-for="(item1, index) in row1.item.TallyBillingSeries.split(',')" :key="index">
                    <b-badge variant="light"><b>{{ item1 == "" ? "-------" : item1 }}</b></b-badge><br />
                  </span>
                </div>
              </div>
              <div class="text-left" v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
              <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.JOBNO"
                  />
              <ContainerSummary v-if="row1.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row1.item.JOBNO" :PMC_JOBID="row1.item.allModuleId"
                :PMC_JOBNO="row1.item.JOBNO" :PMC_JOBDATE="row1.item.JOBDate" :PMC_JOBTYPE="row1.item.JOBTYPE"
                :PMC_AgentType="''" :PMC_Client="row1.item.clientName" :PMC_Sline="row1.item.shippingLine" />
              <AssignmentSplitMergeSummary v-if="row1.item.allModuleId"
                :PMC_title="'Assignment Split/Merge/Move Summary Job No - ' + row1.item.JOBNO" :PMC_JOBID="row1.item.allModuleId"
                :PMC_JOBNO="row1.item.JOBNO" :PMC_JOBDATE="row1.item.JOBDate" :PMC_JOBTYPE="row1.item.JOBTYPE"
                :PMC_AgentType="''" :PMC_Client="row1.item.clientName" :PMC_Sline="row1.item.shippingLine" />
            </template>
            <template slot="billingTypeMain" slot-scope="row2">
              <br />
              <span>{{ "Billing Type : " + row2.item.is_billingType_status }}<br /></span>
              <span v-if="
                  row2.item.is_billingType_status == 'Local' ||
                  row2.item.is_billingType_status == 'Both'
                ">{{
                "Local : " +
                (row2.item.billingTypeMain == "Local Billing" ? "Done" : "Pending")
                }}<br /></span>
              <span v-if="
                  row2.item.is_billingType_status == 'Overseas' ||
                  row2.item.is_billingType_status == 'Both'
                ">{{
                "Overseas : " +
                (row2.item.is_manifestation_status == "Yes" ? "Done" : "Pending")
                }}<br /></span><br />
              <span :class="row2.item.oe_payment_date_first == 'Pending' ? 'error' : ''">{{ "Sline Req date : " +
                row2.item.oe_payment_date_first }}</span><br />
            </template>
            <template slot="JOBNO" slot-scope="row3">
              <tr :class="{ blink: isBlinking(row3.item) }" @click="goPage(row3.item)">
                <td>
                  <span>{{ "JOBNO : " + row3.item.JOBNO }}</span><br />
                </td>
              </tr>

              <span>{{ "JOBDate : " + row3.item.JOBDate }}</span><br />
              <span>{{ "RaisedBy : " + row3.item.RaisedBy }}</span><br />
              <span>{{ "MBLNO : " + row3.item.MBLNO }}</span><br />
              <span>{{ "HBLNO : " + row3.item.HBLNO }}</span><br />
              <span>{{ "Tot Cont : " + row3.item.ContainerCount }}</span><br />
            </template>
            <template slot="clientName" slot-scope="row4">
              <span>{{ row4.item.clientName }}</span><br />
              <span>{{ "Exporter : " + row4.item.Exp_clientName }}</span><br />
              <span>{{ "Importer : " + row4.item.Imp_clientName }}</span>
            </template>
            <template slot="shippingLine" slot-scope="row5">
              <span>{{ row5.item.shippingLine }}</span>
            </template>
            <template slot="POR" slot-scope="row6">
              <span>{{ "POR : " + row6.item.POR }}</span><br />
              <span>{{ "POL : " + row6.item.POL }}</span><br />
              <span>{{ "POD : " + row6.item.POD }}</span>
              <span>{{ "FPOD : " + row6.item.FPOD }}</span>
            </template>
            <template slot="leoDate" slot-scope="row10">
              <span :class="row10.item.leoDate == 'Pending' ? 'error' : ''" @click="goLeoHandPage(row10.item)">{{
                row10.item.leoDate }}</span>
            </template>
            <template slot="cc_handoverDate" slot-scope="row11">
              <span :class="row11.item.cc_handoverDate == 'Pending' ? 'error' : ''"
                @click="goLeoHandPage(row11.item)">{{ row11.item.cc_handoverDate }}</span>
            </template>
            <template slot="cc_paymentDate" slot-scope="row12">
              <span :class="row12.item.cc_paymentDate == 'Pending' ? 'error' : ''" @click="goLeoHandPage(row12.item)">{{
                row12.item.cc_paymentDate }}</span>
            </template>

            <template slot="SOB" slot-scope="row14">
              <span :class="row14.item.SOB == 'Pending' ? 'error' : ''">{{
                "P44 : " + row14.item.SOB
                }}</span>
            </template>
            <!-- <template slot="ETA_actual" slot-scope="row15">
              <span :class="row15.item.ETA_estimated == 'Pending' ? 'error' : ''">{{
                "OF ETA Estimated : " + row15.item.ETA_estimated
              }}</span
              ><br />
              <span :class="row15.item.ETA_actual == 'Pending' ? 'error' : ''">{{
                "OF ETA Actual : " + row15.item.ETA_actual
              }}</span>
            </template> -->
          </b-table>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalContainerValid,
  GlobalGetLocation,
} from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import DateRangePicker from "vue2-daterange-picker";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import userBasedClient from "../common/userBasedClient.vue";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", this.$route.path);
      if (globalPermissionStatus("Custom Clearance")) {
        if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
          this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
        } else {
          this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
        }
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }

      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      isLoading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [100, 200, 300],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      docURL: URL_BASE_DOC,
      ExcelBtnName: "Export As Excel",
      activeButtonBranch:
        this.$sessionsStorage.get("branchclientPre") == "1" ? true : false,
      activeUserPreference: this.$sessionsStorage.get("user_pre") === "1" ? true : false,

      Filter: {
        userFilter: this.$sessionsStorage.get("userId"),
      },

      columnMain: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "HJ.",
        },
        {
          key: "Branch",
          mainkey: "Branch",
          label: "Branch",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "billingTypeMain",
          mainkey: "billingTypeMain",
          label: "Booking No",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "JOBNO",
          lmainkey: "JOBNO",
          label: "JOB Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "shippingLine",
          lmainkey: "shippingLine",
          label: "Sline",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "POR",
          mainkey: "POR",
          label: "POR - POL - POD",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "leoDate",
          mainkey: "leoDate",
          label: "Leo Date",
          sortable: true,
          sortDirection: "ASC",
          table: "J.",
        },
        {
          key: "cc_handoverDate",
          mainkey: "cc_handoverDate",
          label: "Handover Date",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "cc_paymentDate",
          mainkey: "cc_paymentDate",
          label: "SB Payment Date",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },

        {
          key: "SOB",
          mainkey: "SOB",
          label: "SOB",
          sortable: true,
          sortDirection: "ASC",
          table: "N.",
        },
        // {
        //   key: "ETA_actual",
        //   mainkey: "ETA_actual",
        //   label: "ETA Destination(Actual, Estimated)",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "O.",
        // },
      ],
      JOBList: [],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
    };
  },

  mounted() {},
  filters: {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    Loading,
    ContainerSummary,
    AssignmentSplitMergeSummary,
    JobWisePaymentsDetails,
    userBasedClient,
    ModelListSelect,
    CustomLoader,
  },

  created() {},

  computed: {},

  watch: {},

  methods: {
    BranchBtnFilter(type) {
      this.activeButtonBranch = !type;

      this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
    },
    closeAssignmentPendencyList() {
      let payload = {};
      payload = {
        itemCode: "closeJobPendency",
        type:
          this.$route.path == "/ccImpPendency"
            ? "cc_imp_job_pendency"
            : "cc_exp_job_pendency",
        user_id: this.$sessionsStorage.get("userId"),
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.JOBPendencyFLAG == 1) {
            localStorage.setItem("cc_exp_job_pendency", data.cc_exp_job_pendency);
            localStorage.setItem("cc_imp_job_pendency", data.cc_imp_job_pendency);
            this.$sessionsStorage.set("cc_exp_job_pendency", data.cc_exp_job_pendency);
            this.$sessionsStorage.set("cc_imp_job_pendency", data.cc_imp_job_pendency);
            if (this.$route.path == "/ccExpPendency") {
              this.$router.push({
                path: "/CCImport/CCExportDetail",
              });
            } else if (this.$route.path == "/ccImpPendency") {
              this.$router.push({
                path: "/CCImport/CCImportDetails",
              });
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on JOBList Error: ", error);
        });
    },
    goLeoHandPage(item) {
      console.log("goLeoHandPage=>", item);
      this.$sessionsStorage.set("editCcImportId", item.ccImportId);
      this.$sessionsStorage.set("editCcType", "Export");
      this.$router.push({
        path: "/CCImport/newCCHandoverToRail",
      });
    },
    goPage(item) {
      this.$sessionsStorage.set("editCcImportId", item.ccImportId);
      this.$sessionsStorage.set("editCcType", "Export");
      if (
        this.$sessionsStorage.get("designation") == "superviser" &&
        this.$sessionsStorage.get("departmentName") == "Port/ICD"
      ) {
        this.$router.push({
          path: "/ccImport/ccHandoverToRail",
        });
      } else if (item.newContainerFlow == "1") {
        this.$router.push({
          path: "/ccImport/newCCExportEntry",
        });
      } else {
        this.$router.push({
          path: "/ccImport/CCExportEntry",
        });
      }
    },
    shouldBlink: function (item) {
      // return item.CustomColorColumn === "red";
    },
    isBlinking: function (item) {
      // return item.CustomColorColumn === "red";
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.getAssignmentPendencyList("Normal", "0", CURRENT, "2", event);
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getAssignmentPendencyList("Excell", "0", "0", "1", "1");
    },
    getAssignmentPendencyList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.JOBList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode:
          this.$route.path == "/ccImpPendency"
            ? "checkCCImpJobPendency"
            : "checkCCExpJobPendency",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        activeButtonBranch: this.activeButtonBranch,
        Filter: this.Filter,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.JOBList.length > 0) {
                this.JOBList = data.JOBList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.JOBList.length > 0) {
                this.JOBList = data.JOBList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on JOBList Error: ", error);
        });
    },

    filterClear() {
      this.filter = "";
      this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
    },

    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.currentPage = 1;
    },

    goBack() {
      window.history.go(-1);
    },
    clearTimeout() {},

    filterClear() {
      this.Filter = {
        userFilter: "",
      };
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
  },
};
</script>

<style>
.table-background thead {
  background-color: #a9e4ce;
  border-color: lightgrey;
  border-bottom-style: none;
  border-style: solid;
  border-width: 2px;
  height: 40px;
  position: sticky;
  top: 0;
  font-size: 11px;
}
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
.md-body-1,
.pendencyBody {
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 20px;
}

.table-background > tbody {
  font-size: 11px;
}

.table-background > thead {
  color: black;
}
.blink {
  animation: blinker 1s linear infinite;
  font-weight: 800;
  color: red;
}
.blink-circle {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  animation: blinker 6s linear infinite; /* 6 seconds for three color changes */
}
@keyframes blinker {
  0%,
  100% {
    background-color: red;
  }
  33% {
    background-color: green;
  }
  66% {
    background-color: blue;
  }
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ccExpPendency.vue?558aeb14